import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import ViewOrderItemService from "../services/ViewOrderItemService";

const useViewOrderItemService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new ViewOrderItemService(client);
  }, [client]);

  return service;
};

export default useViewOrderItemService;
